/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';
import requestV2 from 'utils/requestV2';

const cashService = {
  getListV2: (params: any) => requestV2.get('/legal-entity-cash', { params }),
  getList: (params: any) => request.get('/legal-entity-cash', { params }),
  getCashById: (id: any) => request.get(`/legal-entity-cash/${id}`),
  createCash: (data: any) => request.post('/legal-entity-cash', data),
  deleteCash: (id: any) => request.delete(`/legal-entity-cash/${id}`),
  updateCash: (id: any, data: any) =>
    request.put(`/legal-entity-cash/${id}`, data)
};

export default cashService;
